var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing"},[_c('div',{staticClass:"bg-glow"},[_c('HeroTransportadora',{attrs:{"id":"hero-transportadora"}}),_c('SecaoProblema',{attrs:{"id":"secao-problema"}}),_c('SecaoSolucao',{attrs:{"id":"secao-solucao"}}),_c('SecaoDiferencial',{attrs:{"id":"diferencial"}}),_c('GanchoFinal',{attrs:{"id":"gancho-final"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }